<script>
  import Progress from "../Progress.svelte";
</script>

<style>
  .filter-user-area {
    display: none;
    padding: 0 2rem 1rem;
    margin: -1rem 0 1rem -1rem;
    border-bottom: 1px solid #ddd;
  }

  @media screen and (max-width: 768px) {
    .filter-user-area {
      display: block;
    }
  }
</style>

<div class="filter-user-area">
  <Progress filterVersion={true} />
</div>
